/**
 * A template card in "New workflow": what kind of workflow this is, in the
 * redesign's look (DOP-624). The icon tile and colours are the Workflows
 * table's, so the card the user picks here looks like the row it becomes.
 *
 * The badge says how the workflow runs, in the same words the table's Runs
 * column uses (Quarterly, Manual, On new files).
 */

import { LineChart, type LucideIcon } from "lucide-react";
import React from "react";
import { BODY, PILL } from "./composerStyles";

interface WorkflowTemplateCardProps {
	title: string;
	description: string;
	onSelect: () => void;
	disabled?: boolean;
	icon?: LucideIcon;
	badge?: string;
}

const WorkflowTemplateCard: React.FC<WorkflowTemplateCardProps> = ({
	title,
	description,
	onSelect,
	disabled = false,
	icon: Icon = LineChart,
	badge,
}) => (
	<button
		type="button"
		onClick={onSelect}
		disabled={disabled}
		className="w-full rounded-xl border border-gray-200 bg-white p-4 text-left transition-colors hover:border-[#004C4B] hover:bg-[#fafafa] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#008782] disabled:opacity-60 disabled:hover:border-gray-200 disabled:hover:bg-white"
	>
		<span className="flex items-start gap-3.5">
			<span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#E6F3F3] text-[#004C4B]">
				<Icon className="h-4 w-4" aria-hidden />
			</span>
			<span className="min-w-0 flex-1">
				<span className="flex flex-wrap items-center gap-2">
					<span className="text-[14px] font-semibold text-[#111111]">{title}</span>
					{badge && <span className={PILL}>{badge}</span>}
				</span>
				<span className={`mt-1 block ${BODY}`}>{description}</span>
			</span>
		</span>
	</button>
);

export default WorkflowTemplateCard;
